import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router';

const NotFound = () => {
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <Card className="text-center">
                        <Card.Body>
                            <h1 className="display-1 fw-bold">404</h1>
                            <h2 className="mb-4">Page Not Found</h2>
                            <p className="lead">
                                The page you are looking for could not be found.
                            </p>
                            <Link to="/dashboard">
                                <Button variant="primary">Go Home</Button>
                            </Link>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
export default NotFound;
